<template>
  <div class="wrapper" @mousemove="onMove">
    <span class="fs" @click="toggleFullscreen">⛶</span>
    <video
      ref="video"
      :src="src"
      :poster="poster"
      playsinline="true"
      preload="auto"
      allowfullscreen="allowfullscreen"
      @canplaythrough="updateTime"
      @timeupdate="updateTime"
    />
    <div
      class="video-player"
      :class="{ 'video-player-hover': isHover, 'video-player-scrubbing': isScrubbing, 'video-player-playing': isPlaying, 'video-player-pause': !isPlaying}"
    >
      <p>{{ formatTime(currentTime) }}</p>
      <p @click="togglePlayback" class="playbutton" v-html="isPlaying ? 'PAUSE' : 'PLAY'" />
      <p>{{ formatTime(duration) }}</p>
      <div
        class="video-bar"
        :style="{ '--percentage': percentage }"
        @click="seekTime"
        @mousedown="startScrubbing"
        @mousemove="scrubTime"
        @mouseup="stopScrubbing"
        @mouseout="stopScrubbing"
      />
    </div>
    <div class="caption" v-html="$root.md(caption)" />
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    poster: String,
    caption: String
  },
  data () {
    return {
      isPlaying: false,
      isHover: false,
      timeout: null,
      currentTime: 0,
      duration: 0,
      percentage: 0,
      isScrubbing: false
    }
  },
  mounted () {
    this.playListener = (e) => {
      if (e !== this.src) {
        const video = this.$refs.video
        this.isPlaying = false
        video.pause()
      }
    }
    this.$root.$on('media-play', this.playListener)
  },
  beforeDestroy () {
    this.$root.$off('media-play', this.playListener)
  },
  methods: {
    onMove () {
      console.log(this.isHover)
      this.isHover = true
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => { this.isHover = false }, 3000)
    },
    togglePlayback () {
      const video = this.$refs.video
      if (this.isPlaying) {
        video.pause()
      } else {
        video.play()
        this.$root.$emit('media-play', this.src)
      }
      this.isPlaying = !this.isPlaying
    },
    toggleFullscreen () {
      const video = this.$refs.video
      if (!this.isPlaying) {
        this.togglePlayback()
      }
      if (video.requestFullscreen) {
        video.requestFullscreen()
      } else if (video.webkitRequestFullscreen) { // Safari/Chrome on iOS
        video.webkitRequestFullscreen()
      } else if (video.msRequestFullscreen) { // IE/Edge
        video.msRequestFullscreen()
      } else if (video.webkitEnterFullscreen) { // Legacy Safari
        video.webkitEnterFullscreen()
      }
    },
    updateTime () {
      const video = this.$refs.video
      this.currentTime = video.currentTime
      this.duration = video.duration
      this.percentage = (1 / video.duration) * video.currentTime
    },
    formatTime (time) {
      const minutes = Math.floor(time / 60)
      const seconds = Math.floor(time % 60)
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0'
      )}`
    },
    seekTime (event) {
      const video = this.$refs.video
      const rect = event.target.getBoundingClientRect()
      const offsetX = event.clientX - rect.left
      const percentage = (1 / rect.width) * offsetX
      video.currentTime = percentage * video.duration
    },
    startScrubbing () {
      this.isScrubbing = true
    },
    scrubTime (event) {
      if (this.isScrubbing) {
        this.seekTime(event)
      }
    },
    stopScrubbing () {
      this.isScrubbing = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../main";

.video-player {
  @include headerfont;
  margin: auto;
  width: 100%;
  // border: 1px solid;
  height: var(--menuwidth-hidden);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  cursor: pointer;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.5s;
}
.video-player-scrubbing {
  p {
    pointer-events: none;
  }
  .video-bar {
    &:after {
      transition: none;
    }
  }
}
.playbutton {
  &:before {
    content: '';
    display: inline-block;
    width: 1rem;
    height: .9rem;
    padding-right: 0.5rem;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><polygon points="0,0 70,50 0,100" fill="white"/></svg>') no-repeat center center;
    background-size: contain;
  }
}
.video-player-playing {
  .playbutton {
    &:before {
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect x="0" y="0" width="33" height="100" fill="white"/><rect x="50" y="0" width="33" height="100" fill="white"/></svg>') no-repeat center center;
    }
  }
}
.video-player-pause,
.video-player-hover {
  opacity: 1
}
.wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
}
.fs {
    position: absolute;
    padding: var(--padding-05) var(--padding);
    right: 0px;
    top: 0px;
    cursor: pointer;
    z-index: 2;
}
video {
  width: 100%;
  height: auto;
  margin-bottom: calc(-1*var(--menuwidth-hidden));
  z-index: 1;
  &[poster]{
    object-fit: cover;
  }
}

.video-bar {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  &:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0px;
    top: 0px;
    z-index: 0;
    background: white;
    transform: scaleX(var(--percentage));
    transition: transform 0.5s;
    transform-origin: left center;
  }
}

p {
  color: white;
  margin: 0;
  z-index: 1;
  padding: var(--padding-05);
  mix-blend-mode: difference;
  flex-basis: 4em;
  text-align: center;
  white-space: nowrap;
  @include hover() {
    color: var(--link-hover-color);
  }
  &:first-of-type {
    text-align: left;
    pointer-events: none;
  }
  &:last-of-type {
    text-align: right;
    pointer-events: none;
  }
}

.caption {
  @include smallfont;
  padding-top: var(--padding-05);
}
</style>



// WEBPACK FOOTER //
// src/components/Videoplayer.vue